module.exports = __webpack_public_path__ + "img/South Korea.77a66c9c.svg";